import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAlphabetic]'
})
export class AlphabeticDirective {

  private patternRegex = /^[A-Za-z\s]*$/;

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    debugger;
    const value = event.target.value;
    const formattedValue = this.formatInput(value);
    event.target.value = formattedValue;
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    debugger;
    const input = String.fromCharCode(event.keyCode);
    if (!this.patternRegex.test(input)) {
      event.preventDefault();
    }
  }

  private formatInput(value: string): string {
    return value.replace(/[^A-Za-z\s]/g, '');
  }

}
